import styled from 'styled-components';
import { breakpoint } from 'styles/globals';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;

  @media (${breakpoint.lgMin}) and (${breakpoint.xlMax}) {
    padding: 0 24px;
  } 
`;

export const StickyNavWrapper = styled.div`
  width: 100%;
  @media (${breakpoint.mdMax}) {
    padding: 0 16px;
    width: 93vw;
  }

  @media (${breakpoint.mdMin}) {
    width: 200px;
  }

  @media (${breakpoint.xxlMin}) {
    width: 260px;
  }
`;

export const Content = styled.div`
  flex: auto;
  width: 100%;

  @media (${breakpoint.mdMin}) {
    padding-left: 24px;
    width: calc(100% - 200px);
  }

  @media (${breakpoint.xxlMin}) {
    width: calc(100% - 260px);
  }
`;
